import React from 'react'

const Footer = () => {

    return (
        <div className='footer'>
            <p>Made with 💛 in Zoetermeer, The Netherlands</p>
            <p>© 2020 Sander Vreeken</p>
        </div>
    )
}

export default Footer